// Knižnica 5 profesionálnych obchodných stratégií, každá so
// všetkými poľami požadovanými stránkou s detailmi. Rovnaká štruktúra
// pre budúce stratégie pridané bez úpravy komponentu.

export const ESTRATEGIAS = [
  {
    id: "smc-order-block",
    nombre: "SMC — Vstup na Order Block",
    tipo: "tendencia",
    mercados: ["BTC", "ETH", "Altcoins"],
    timeframes: ["1H", "4H", "D"],
    dificultad: "intermedia",
    winRate: "55-65%",
    ratioRR: "1:3 — 1:5",
    descripcion: "Inštitucionálny vstup v zónach Order Block po prelomení štruktúry (BOS). Je to kľúčová stratégia Smart Money Concepts. Hľadáme, aby sa cena vrátila otestovať zónu, kde inštitucionálni hráči umiestnili svoje príkazy, a vstúpime spolu s nimi.",
    condicionesEntrada: [
      "1. Identifikovať trend na vyššom timeframe (D alebo 4H).",
      "2. Čakať na Break of Structure (BOS) v smere trendu.",
      "3. Identifikovať Order Block, ktorý spôsobil BOS (posledná opačná sviečka pred impulzom).",
      "4. Čakať, až sa cena vráti do rozsahu Order Block (retracement).",
      "5. Potvrdiť štruktúrou na nižšom timeframe (1H alebo 15m): bullish CHoCH na OB.",
      "6. Vstúpiť v hornej polovici OB (zóna diskontu v rámci OB).",
    ],
    stopLoss: "Pod minimom Order Block (s malým marginom 0,5 %).",
    takeProfit: "Ďalšia zóna likvidity / predchádzajúce maximum / Fibonacci extenzia 161,8 %.",
    ejemploReal: "BTC na 4H ukazuje bullish BOS prelomením 44 000. Bullish OB je medzi 42 800-43 200 (posledná červená sviečka pred impulzom). Cena sa vracia na 43 000, na 1H sa formuje bullish CHoCH. Vstup na 43 100, SL na 42 700, TP na 45 500. R:R ≈ 1:3.",
    erroresComunes: [
      "Vstúpiť na OB bez čakania na potvrdenie na nižšom timeframe.",
      "Nesprávne identifikovať trend vyššieho timeframe.",
      "Umiestniť SL príliš tesno v rámci OB — cena ho môže vybrať.",
      "Zameniť OB s náhodnou konsolidačnou zónou.",
    ],
    consejosPro: [
      "OB s FVG nad nimi sú silnejšie — dvojitá inštitucionálna konfluencia.",
      "Najplatnejší OB je ten, ktorý spôsobil najnovší BOS.",
      "Lepšie ignorovať OB, ktoré boli testované viac ako 2-krát.",
      "Kombinovať s likviditou: vstúpiť, keď cena najprv zbiera stopy a potom sa vracia na OB.",
    ],
  },
  {
    id: "fvg-fill",
    nombre: "FVG Fill — Vypĺňanie neefektívností",
    tipo: "reversion",
    mercados: ["BTC", "ETH", "Všetky"],
    timeframes: ["15m", "1H", "4H"],
    dificultad: "basica",
    winRate: "60-70%",
    ratioRR: "1:2 — 1:3",
    descripcion: "Cena má tendenciu vracať sa vypĺňať Fair Value Gaps (FVG) vytvorené prudkými impulzmi. Táto stratégia využíva túto tendenciu trhu hľadať cenovú rovnováhu. Jednoduchá a s vysokou pravdepodobnosťou, keď sa používa v konfluencii so štruktúrou.",
    condicionesEntrada: [
      "1. Identifikovať silný impulz (bullish alebo bearish) s viditeľným FVG.",
      "2. FVG je priestor medzi horným knôtom sviečky 1 a dolným knôtom sviečky 3.",
      "3. Čakať, kým sa cena vráti smerom k FVG.",
      "4. Lepšie, ak sa FVG zhoduje s Order Block alebo zónou podpory/odporu.",
      "5. Vstúpiť na 50 % FVG (polovica gapu).",
      "6. Potvrdiť sviečkou odmietnutia alebo štruktúrou na nižšom TF.",
    ],
    stopLoss: "Pod kompletným FVG (ak cena prejde celým, FVG už nie je platný).",
    takeProfit: "Extrém odkiaľ sa FVG formoval — pôvodný impulz.",
    ejemploReal: "ETH bullish impulz z 2 200 na 2 450. FVG medzi 2 280-2 320. Cena sa vracia na 2 300, doji sviečka nerozhodnosti. Vstup na 2 300, SL na 2 270, TP na 2 420. R:R ≈ 1:4.",
    erroresComunes: [
      "Vstúpiť na FVG, ktoré už boli vyplnené — vyplnený FVG stráca svoj magnetizmus.",
      "Ignorovať makro trend — obchodovať FVG proti trendu má nižšiu pravdepodobnosť.",
      "Veľmi malé FVG (<0,5 %) majú nižšiu štatistickú spoľahlivosť.",
    ],
    consejosPro: [
      "FVG v konfluencii s Order Blocks sú najsilnejšie.",
      "FVG vyplnený napoly (50 %) a odmietnutý je veľmi silný signál.",
      "V bullish trende obchodujte len bullish FVG. Nebojujte proti trendu.",
      "FVG pri otvorení sedenia (Londýn, NY) majú vysokú mieru vyplnenia.",
    ],
  },
  {
    id: "wyckoff-accumulation",
    nombre: "Wyckoff — Vstup v akumulácii",
    tipo: "reversion",
    mercados: ["BTC", "ETH"],
    timeframes: ["4H", "D", "W"],
    dificultad: "avanzada",
    winRate: "50-60%",
    ratioRR: "1:5 — 1:10",
    descripcion: "Richard Wyckoff vyvinul v 30. rokoch 20. storočia metódu na pochopenie toho, ako inštitucionálni obchodníci akumulujú a distribuujú pozície. Fáza akumulácie je obdobie, keď veľkí hráči tichо nakupujú pred veľkým rastom. Jej správna identifikácia ponúka najlepšie R:R na trhu.",
    condicionesEntrada: [
      "1. Preliminary Support (PS): prvý odraz po silnom poklese — prvá známka nákupného záujmu.",
      "2. Selling Climax (SC): extrémna bearish sviečka s veľmi vysokým objemom — panický predaj.",
      "3. Automatic Rally (AR): silný odraz od SC — definuje strop rozsahu.",
      "4. Secondary Test (ST): vracia sa na úroveň SC, ale s nižším objemom — potvrdenie.",
      "5. Creek (odpor): cena osciluje v rozsahu, tvorí maximá a minimá.",
      "6. Jump Across the Creek (JAC): jasný prelom stropu rozsahu s objemom.",
      "7. Back Up to the Creek (BU): retest prolomenia — posledná príležitosť na vstup.",
      "8. Vstup na BU s SL pod rozsahom akumulácie.",
    ],
    stopLoss: "Zatvorenie dennej sviečky pod rozsahom akumulácie (Selling Climax).",
    takeProfit: "Projekcia výšky rozsahu akumulácie × 2-3 od prolomenia.",
    ejemploReal: "BTC v 2020: rozsah akumulácie 6 000-12 000. SC v marci 2020 (~4 000). AR na 10 000. Rozsah 6K-12K počas 6 mesiacov. JAC v októbri 2020. BU na 12 000. Vstup 12 500, SL 9 000, TP cieľ 30 000+. Reálne R:R: 1:10+.",
    erroresComunes: [
      "Identifikovať akumulácie tam, kde je len distribúcia — zamieňať fázy.",
      "Vstúpiť pred JAC — rozsah môže trvať týždne alebo mesiace.",
      "Nečakať na BU — vstúpiť na JAC s nižším R:R.",
    ],
    consejosPro: [
      "Objem je kľúčový vo Wyckoff — bez objemu nie je potvrdenie.",
      "Dlhšie rozsahy akumulácie (3-6 mesiacov) produkujú najlepšie pohyby.",
      "BTC na týždennom grafe ukazuje Wyckoff veľmi jasne v 2019-2020 a 2022-2023.",
      "Kombinovať s on-chain: Wyckoff akumulácia + Exchange Outflow = veľmi silný signál.",
    ],
  },
  {
    id: "breakout-retest",
    nombre: "Breakout + Retest odporu",
    tipo: "ruptura",
    mercados: ["Všetky"],
    timeframes: ["1H", "4H", "D"],
    dificultad: "basica",
    winRate: "55-65%",
    ratioRR: "1:2 — 1:4",
    descripcion: "Jedna z najklasickejších a najúčinnejších stratégií. Cena prelomí kľúčový odpor s objemom, vráti sa otestovať túto úroveň (teraz podporu) a ponúka vstup s nízkym rizikom v smere trendu. Retest potvrdzuje, že starý strop je nové dno.",
    condicionesEntrada: [
      "1. Identifikovať dobre definovaný odpor (minimálne 2-3 predchádzajúce dotýkania).",
      "2. Čakať na prelom so sviečkou JASNE zatvorenou nad odporom.",
      "3. Potvrdiť objemom vyšším ako priemer na sviečke prolomenia.",
      "4. Čakať na retest — cena sa vracia dotknúť prelomenú líniu.",
      "5. Pri reteste hľadať sviečku odmietnutia (doji, kladivo, engulfing) na úrovni.",
      "6. Vstup pri zatvorení potvrdzujúcej sviečky retestu.",
    ],
    stopLoss: "Pod minimom potvrdzujúcej sviečky retestu (alebo pod prelomeným odporom).",
    takeProfit: "Projekcia výšky predchádzajúceho rozsahu od úrovne prolomenia.",
    ejemploReal: "BTC odpor na 48 000 so 4 dotýkaniami za 2 mesiace. Prelom dennou sviečkou, ktorá zatvorí na 49 500 s objemom x2. Retest na 48 200, kladivo potvrdenia. Vstup 48 500, SL 47 200, TP 54 000. R:R ≈ 1:4.",
    erroresComunes: [
      "Vstúpiť NA prelome bez čakania na retest — vysoké riziko falošného prelomenia.",
      "Retest nemusí vždy prísť na presnú úroveň — dať priestor ±1-2 %.",
      "Breakouty bez objemu majú vysokú mieru zlyhania.",
    ],
    consejosPro: [
      "Ideálny retest sa dotkne úrovne s nižším objemom ako prelom.",
      "Ak retest klesne výrazne pod úroveň, setup je neplatný.",
      "Kombinovať s EMA200 alebo Order Block ako ďalšiu konfluenciu.",
      "V kryte sú breakouty historických maxím (ATH) obzvlášť silné.",
    ],
  },
  {
    id: "london-breakout",
    nombre: "London Open Breakout",
    tipo: "ruptura",
    mercados: ["BTC", "ETH"],
    timeframes: ["15m", "1H"],
    dificultad: "basica",
    winRate: "55-60%",
    ratioRR: "1:2 — 1:3",
    descripcion: "Londýnske sedenie (7:00-10:00 CET) je najvolatilnejšie na krypto trhu spolu s otvorením NY. Európski inštitucionálni hráči vstupujú na trh a vytvárajú priame pohyby. Cena zvyčajne prelomí rozsah vytvorený počas ázijskej noci.",
    condicionesEntrada: [
      "1. Identifikovať rozsah ázijského sedenia (00:00-07:00 CET): maximum a minimum.",
      "2. Označiť tieto úrovne na 15-minútovom grafe.",
      "3. Od 07:00 CET čakať na prelomenie ázijského rozsahu.",
      "4. Vstúpiť pri zatvorení prvej 15m sviečky, ktorá jasne prelomí rozsah.",
      "5. Alternatíva: čakať na mikro-retest prelomeného rozsahu na 5 minút.",
    ],
    stopLoss: "Na opačnom konci ázijského rozsahu.",
    takeProfit: "Projekcia výšky ázijského rozsahu od bodu prolomenia.",
    ejemploReal: "BTC v rozsahu 43 500-44 200 počas noci. O 7:15 CET sa 15m sviečka zatvorí na 44 350. Vstup 44 350, SL 43 500, TP 44 900.",
    erroresComunes: [
      "Obchodovať London Breakout proti 4H trendu.",
      "Dni s dôležitými makroekonomickými udalosťami: nepoužívať túto stratégiu.",
      "Veľmi úzky ázijský rozsah (<0,5 %) dáva zlé R:R.",
    ],
    consejosPro: [
      "Funguje lepšie, keď ázijský rozsah trvá celú noc bez fakeoutov.",
      "Kombinovať s makro smerom dňa: ak je trh v bullish trende, len prolomenia smerom hore.",
      "Pondelky a útorok majú štatisticky najčistejšie London Breakouty.",
    ],
  },
];

export const ESTRATEGIA_TIPOS = [
  { id: "todas", label: "Všetky" },
  { id: "tendencia", label: "Trend" },
  { id: "reversion", label: "Reverzia" },
  { id: "ruptura", label: "Prolomenie" },
  { id: "rango", label: "Rozsah" },
  { id: "scalping", label: "Scalping" },
];

export const ESTRATEGIA_NIVELES = [
  { id: "todas", label: "Všetky" },
  { id: "basica", label: "Základná" },
  { id: "intermedia", label: "Stredná" },
  { id: "avanzada", label: "Pokročilá" },
];

export const TIPO_COLORS = {
  tendencia: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  reversion: "border-cyan-400/40 bg-cyan-400/[0.08] text-cyan-200",
  ruptura: "border-orange-400/40 bg-orange-400/[0.08] text-orange-200",
  rango: "border-purple-400/40 bg-purple-400/[0.08] text-purple-200",
  scalping: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const NIVEL_COLORS = {
  basica: "border-emerald-400/40 bg-emerald-400/[0.08] text-emerald-200",
  intermedia: "border-amber-400/40 bg-amber-400/[0.08] text-amber-200",
  avanzada: "border-red-400/40 bg-red-400/[0.08] text-red-200",
};

export const findEstrategia = (id) => ESTRATEGIAS.find((e) => e.id === id);